import type { LalKitabLocale } from "./LalKitabKundliPage.types";

export const RESULT_COPY = {
  en: {
    assessment: "Overall Assessment",
    good: "Good",
    needsUpay: "Need Upay",
    activeUpay: "Active Upay",
    planetPlacements: "Planet Placements (Lal Kitab)",
    planet: "Planet",
    house: "House",
    effect: "Effect",
    comfortable: "Comfortable",
    remedies: "Active Upay (Remedies)",
    remediesBody:
      "These remedies apply to planets placed in houses that Lal Kitab marks as uncomfortable for them. Performing these upay regularly — especially on the specified day — is the core Lal Kitab prescription.",
    debts: "Ancestral Debts (Rin / ऋण)",
    debtsBody:
      "Lal Kitab identifies specific planet-house combinations as indicators of karmic debts. Clearing these through the prescribed upay is considered essential for removing blockages in career, family, and health.",
    donate: "Donate",
    feed: "Feed",
    gemstone: "Gemstone (optional)",
    gemstoneAdvice:
      "Traditionally some people also wear this gemstone. It is optional and secondary to the upay above; nothing needs to be bought. Consult an astrologer before wearing any gemstone.",
    remedy: "Remedy",
  },
  hi: {
    assessment: "समग्र आकलन",
    good: "शुभ",
    needsUpay: "उपाय चाहिए",
    activeUpay: "सक्रिय उपाय",
    planetPlacements: "ग्रह स्थिति (लाल किताब)",
    planet: "ग्रह",
    house: "भाव",
    effect: "प्रभाव",
    comfortable: "अनुकूल",
    remedies: "सक्रिय उपाय",
    remediesBody:
      "ये उपाय उन ग्रहों के लिए हैं जिन्हें लाल किताब उनकी भाव स्थिति में असहज मानती है। इन्हें नियमित रूप से, विशेषकर बताए गए दिन पर करना, लाल किताब की मूल पद्धति है।",
    debts: "पैतृक ऋण (Rin / ऋण)",
    debtsBody:
      "लाल किताब कुछ ग्रह-भाव योगों को कर्म ऋण का संकेत मानती है। बताए गए उपाय करियर, परिवार और स्वास्थ्य की रुकावटों को समझने और कम करने के लिए दिए जाते हैं।",
    donate: "दान",
    feed: "खिलाएं",
    gemstone: "रत्न (वैकल्पिक)",
    gemstoneAdvice:
      "परंपरागत रूप से कुछ लोग यह रत्न भी पहनते हैं। यह वैकल्पिक है और ऊपर दिए उपायों के बाद आता है; कुछ भी खरीदना आवश्यक नहीं। कोई भी रत्न पहनने से पहले ज्योतिषी से सलाह अवश्य लें।",
    remedy: "उपाय",
  },
} as const;

export const HINDI_OVERALL_LABEL: Record<string, string> = {
  mostly_positive: "अधिकतर शुभ",
  mixed: "मिश्रित",
  challenging: "चुनौतीपूर्ण",
};

export const OVERALL_CLASS: Record<string, string> = {
  mostly_positive: "text-intent-success",
  mixed: "text-ritual-gold",
  challenging: "text-intent-error",
};

export type ResultLocale = LalKitabLocale;
